import type { RootState } from 'store'
import type { Module } from 'vuex'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { state } from './state'
import type { ApplicationState } from './types'

export const application: Module<ApplicationState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
